import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import { C as Collection } from './collection-CkQ2H26o.js';
import './uniq-BDEfcc0N.js';
import './fetchHTML-CGNR3V1z.js';
import './parseHTML-Om2c1Ayj.js';

/**
 * Get the section id from an id
 * @param {string} id - The id to get the section id from
 * @returns {string} - The section id
 */
function getSectionId({ id = '' }) {
  return id.includes('__') ? id.split('__').pop() : id.replace('shopify-section-', '');
}

class ListingGrid extends HTMLElement {
  #unsubscriber;
  #closestSection = this.closest('[id^="shopify-section-"]');
  #sectionId = getSectionId(this.#closestSection);
  #listingGridColsStorageKey = 'listing-grid-cols';
  #defaultCols = '2';

  connectedCallback() {
    Collection.sections.push(this.#sectionId);

    this.#applyCols(this.#getStoredCols());
    this.addEventListener('change', (event) => this.#onColsChange(event));

    // Subscribe to filters updated event
    this.#unsubscriber = PubSub.subscribe('collection:filter', ({ status, data }) => {
      status === 'success' && this.#replaceListingGrid(data.sections);
    });
  }

  disconnectedCallback() {
    this.#unsubscriber();
  }

  /**
   * Handle grid view toggle change
   * @param {Event} event - Change event
   */
  #onColsChange(event) {
    const input = event.target.closest('[data-listing-grid-cols-input]');
    if (!input || !this.contains(input)) return;

    this.#applyCols(input.value);
  }

  /**
   * Get stored column preference from sessionStorage
   * @returns {string}
   */
  #getStoredCols() {
    const stored = sessionStorage.getItem(this.#listingGridColsStorageKey);
    return stored || this.#defaultCols;
  }

  /**
   * Apply column preference to the listing grid and sync toggle UI
   * @param {string} cols - Column count ('1' or '2')
   */
  #applyCols(cols) {
    this.dataset.listingGridCols = cols;
    sessionStorage.setItem(this.#listingGridColsStorageKey, cols);

    const input = this.querySelector(`[data-listing-grid-cols-input][value="${cols}"]`);
    if (input) input.checked = true;
  }

  /**
   * Replace listing grid
   * @param {object[]} sections - Sections to replace
   * @param {string} sections.section - Section to replace
   * @param {Document} sections.html - Html to replace the current listing grid
   */
  #replaceListingGrid(sections) {
    const section = sections.find(({ section }) => section === this.#sectionId);
    if (!section) return;

    const parsedListingGrid = section.html.querySelector('listing-grid');

    // Clone the element to avoid modifying the shared HTML object
    const clonedListingGrid = parsedListingGrid.cloneNode(true);

    this.innerHTML = clonedListingGrid.innerHTML;
    this.#applyCols(this.#getStoredCols());
  }
}

customElements.define('listing-grid', ListingGrid);
